import { useCompanyApi } from '@lendica/hooks';
import { useMemo } from 'react';
import { v2 } from '@lendica/api';
import {
    OfferTermsInvitation,
    OfferTermsInvitationDetail,
    Company,
    DeepPartial,
} from '@lendica/utils';

export const useOfferTermsApi = () => {
    const api = useCompanyApi();
    return useMemo(
        () => ({
            getInvitationsList: (page = 1, pageSize = 20, isArchived = false, status?: string) =>
                api.get<v2.PaginatedResponse<OfferTermsInvitation>>(
                    '/offerterms/invitations/list',
                    {
                        params: { page, page_size: pageSize, is_archived: isArchived, status },
                    }
                ),
            previewInvitation: (companyName: string, email: string) =>
                api.post<OfferTermsInvitationDetail>(
                    '/offerterms/invitations/preview',
                    {
                        company_name: companyName,
                        email,
                    },
                    { unwrap: false }
                ),
            getInvitationByID: (invitationId: string) =>
                api.get<OfferTermsInvitationDetail>('/offerterms/invitations/detail', {
                    params: { invitation_id: invitationId },
                }),
            submitInvitation: (
                invitationId: string,
                companyName: string,
                email: string,
                emailContent: string
            ) =>
                api.post(
                    '/offerterms/invitations/submit',
                    {
                        invitation_id: invitationId,
                        company_name: companyName,
                        email,
                        email_content: emailContent,
                    },
                    { unwrap: false }
                ),
            resendInvitation: (invitationId: string) =>
                api.post(
                    '/offerterms/invitations/resend',
                    { invitation_id: invitationId },
                    { unwrap: false }
                ),
            archiveInvitation: (invitationId: string) =>
                api.post(
                    '/offerterms/invitations/archive',
                    { invitation_id: invitationId },
                    { unwrap: false }
                ),
            updateCompany: (companyId: string, company: DeepPartial<Company>) =>
                api.post(
                    '/companies/update',
                    { company_id: companyId, ...company },
                    { unwrap: false }
                ),
        }),
        [api]
    );
};
